import Vue from 'vue'

const components = {
  DialogBaseCloseIcon: () => import('./DialogBaseCloseIcon'),
  DialogBaseTitle: () => import('./DialogBaseTitle'),
  DialogBaseColoredTitle: () => import('./DialogBaseColoredTitle'),
  DialogBaseText: () => import('./DialogBaseText'),
  DialogBaseActions: () => import('./DialogBaseActions')
}

Object.entries(components).forEach(([name, component]) =>
  Vue.component(name, component)
)

export default {}
